import React from "react";
import { NavLink } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import styles from "./bread_crumbs.module.css";
import { useSelector } from "react-redux";
import { getRoutes, getCategories } from "../../services/selectors";
import { deepFindByPath } from "../../utils/util_functions";


const Breadcrumbs = ({ onlyEnd }) => {

  const routes = useSelector(getRoutes);
  const { categories } = useSelector(getCategories);
  const breadcrumbs = useBreadcrumbs(routes);

  const getRoute = (matchPathName) => {
    if (categories.length > 0 && deepFindByPath(categories, matchPathName.replace('/products', '/catalog'))) {
      return matchPathName.replace('/products', '/catalog');
    }
    return matchPathName;
  }

  return (
    <nav className={`${styles.container}`}>
      {onlyEnd ?
        <>
          <NavLink
            to={`${breadcrumbs[0].match.pathname}`} end
            className={({ isActive }) => `${isActive ? styles.crumbsLinkActive : styles.crumbsLink}`}
          >
            {breadcrumbs[0].breadcrumb}
          </NavLink>
          <NavLink
            to={`${breadcrumbs[breadcrumbs.length - 1].match.pathname}`} end
            className={({ isActive }) => `${isActive ? styles.crumbsLinkActive : styles.crumbsLink}`}
          >
            {breadcrumbs[breadcrumbs.length - 1].breadcrumb}
          </NavLink>
        </>
        : breadcrumbs.map(({ match, breadcrumb }) => (
          <NavLink
            key={match.pathname}
            // to={`${match.pathname}`}
            to={getRoute(match.pathname)}
            end
            className={({ isActive }) => `${isActive ? styles.crumbsLinkActive : styles.crumbsLink}`}
          >
            {breadcrumb}
          </NavLink>
        ))}
    </nav>
  );
};

export default Breadcrumbs;
